import React from 'react';
import IconBase from './IconBase';

const StudentIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M12 19.6q-.225 0-.438-.062-.212-.063-.437-.163l-4.675-2.55q-.45-.25-.7-.662-.25-.413-.25-.938V10.9l-2-1.1q-.25-.15-.362-.35-.113-.2-.113-.45t.113-.45q.112-.2.362-.35l7.625-4.15q.225-.125.437-.175.213-.05.438-.05t.438.062q.212.063.437.163l8.6 4.7q.25.125.363.337.112.213.112.463v5.9q0 .3-.212.525-.213.225-.538.225-.3 0-.525-.225-.225-.225-.225-.525V9.825L18.5 10.9v4.325q0 .525-.25.938-.25.412-.7.662l-4.675 2.55q-.225.1-.437.163-.213.062-.438.062Zm-.125-6.95q.075.025.125.025t.125-.025L18.85 9l-6.725-3.625q-.075-.05-.125-.05t-.125.05L5.15 9Zm0 5.425q.075.025.125.025t.125-.025l4.725-2.55q.075-.05.112-.113.038-.062.038-.162V11.7l-4.125 2.25q-.2.125-.425.175-.225.05-.45.05t-.45-.05q-.225-.05-.425-.175L7 11.7v3.55q0 .075.037.15.038.075.113.125ZM12 12.7Zm0 2.35Zm0 0Z"/>
        </IconBase>
    )
}

export default StudentIcon;